import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <Section dark className="border-y-8 border-white" data-id="element-86">
      <div className="grid md:grid-cols-12 gap-12" data-id="element-87">
        <div className="md:col-span-4" data-id="element-88">
          <h2 className="text-6xl md:text-8xl font-bold text-white leading-none sticky top-24" data-id="element-89">
            EL <br data-id="element-90" />
            PROBLEMA <br data-id="element-91" />
            <span className="text-red-600" data-id="element-92">REAL</span>
          </h2>
        </div>

        <div className="md:col-span-8 space-y-12" data-id="element-93">
          <div className="space-y-6 text-2xl md:text-3xl font-light text-gray-300" data-id="element-94">
            <p className="border-l-4 border-gray-700 pl-6" data-id="element-95">
              No es la economía.
            </p>
            <p className="border-l-4 border-gray-700 pl-6" data-id="element-96">No es tu jefe.</p>
            <p className="border-l-4 border-gray-700 pl-6" data-id="element-97">
              No es que "no tengas suerte".
            </p>
          </div>

          <div className="bg-white text-black p-8 md:p-12 shadow-brutal-white transform -rotate-1" data-id="element-98">
            <h3 className="text-xl font-bold uppercase tracking-widest mb-4 text-gray-500" data-id="element-99">
              Es este momento específico:
            </h3>
            <p className="text-2xl md:text-4xl font-serif font-bold leading-tight" data-id="element-100">
              “Llegas al final del día cansado, abres Instagram o YouTube
              buscando una salida… ves otro gurú hablando de dinero fácil… lo
              guardas… y mañana sigues igual.”
            </p>
            <div className="mt-6 flex justify-end" data-id="element-101">
              <span className="bg-black text-white px-4 py-2 font-mono text-sm uppercase" data-id="element-102">
                Y repites eso por años
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}